import type { CSSProperties } from 'react';
import logoUrl from '../assets/hopper-logo.svg';

export type HopperLogoProps = {
  variant?: 'full' | 'mark';
  size?: number | string;
  className?: string;
};

export function HopperLogo({ variant = 'full', size = 32, className }: HopperLogoProps) {
  const markStyle: CSSProperties = {
    width: size,
    height: size,
  };

  if (variant === 'mark') {
    return (
      <img
        className={['hopper-ui-logo', 'hopper-ui-logo--mark', className].filter(Boolean).join(' ')}
        src={logoUrl}
        alt="Хоппер"
        style={markStyle}
      />
    );
  }

  return (
    <span
      className={['hopper-ui-logo', 'hopper-ui-logo--full', className].filter(Boolean).join(' ')}
      role="img"
      aria-label="Хоппер"
    >
      <img src={logoUrl} alt="" aria-hidden="true" style={markStyle} />
      <span className="hopper-ui-logo__wordmark">Хоппер</span>
    </span>
  );
}
